const state = {
    //apiAdress: 'http://192.168.1.215:8786',
    //apiAdress: 'http://192.168.50.10:8786',
    //apiAdress2: 'http://localhost:51953',
    //apiAdress1: 'http://omnic.hopto.org:8786',
    //apiAdress3: 'http://209.104.101.100:8786',

    apiAdress: 'http://192.168.30.70:8786',
    apiAdress2: 'http://localhost:51953',
    apiAdress1: 'http://omnic.hopto.org:7788',
    apiAdress3: 'http://209.104.101.100:7788',
    apiAdress4: 'http://192.168.30.216:7788',
    //apiAdress5: 'http://192.168.30.217:21703',
    apiAdress5: 'http://servexacomba.ca:21703',
    apiAdress6: 'http://192.168.30.119:8081', //Api management Krakend
    apiAdd: {
        portail: {
            apiUser: '/api/portailUser',
            apiLicence: '/api/licence',
            apiLicenceNumber: '/api/licenceNumber',
            apiMagasin: '/api/magasin',
            apiDatabase: '/api/Database',
            apiDatabasedbCreate: '/api/dbCreate'
        },
        magasin: {
            apiComptes: '/api/v1//accounting/account',
            apiExercises: '/api/v1/configurations/exercises',
            apiPeriods: '/api/periods',
            apiTaxes: '/api/configurations/taxes',
            apiTaxesConfigGL: '/api/configurations/taxesConfigGL',
            apiClientAccount: '/api/v1/clientAccount',
            apiSupplier: '/api/v1/supplier',
            apiSupplierContact: '/api/v1/suppliercontact',
            apiClientContact: '/api/v1/clientcontact',
            apiClientGroup: '/api/clientGroup',
            apiItems: '/api/v1/items',
            apiItemInfo: '/api/v1/iteminfo',
            apiItemSections : '/api/v1/item/sections',
            apiItemPriceGroup : '/api/v1/itemPriceGroup',
            apiItemFilter : '/api/v1/itemFilter',
            apiCategory : '/api/v1/category',
            apiDepartment : '/api/v1/department'
            
        },
        configuration: {
            apiConfigAll: '/api/configurations'
        },
        debug: {
            apiLogEr: '/api/logEr',
        },
        key: {
            keyM: '123456789',
            keyU: '987654321',
            user:'77766557639877-695b-4cec-b5a7-01b098811e02',
            pass:'lkx6Vxn2xfYeIbBgINbgZbzVZe6CNi30dBjgsO4NhgDNYV0tBCspeAC5Sn9cSlovJjyl6M586W4gDWUWdzJEweYxiKQMC0evBZVZKglwTvcmHNecMe+nhp/ibxbUp9Pnk1Th1L4vGfzaLNI+aRsclKLLyMCgyuc9ppd4QzPNrBI='
        }
    }
}
const getters = {
    getApiAdress: () => {
        //apiAdress: 'http://192.168.50.10:8786', - INTERNE
        //apiAdress2: 'http://localhost:51953', - DEBUG
        //apiAdress1: 'http://omnic.hopto.org:8786', - EXTERNE
        return state.apiAdress5
        //return state.apiAdress2
        //return state.apiAdress6
    },
    getApiAdd: () => {
        return state.apiAdd
    },
    getApiKey: () => {
        return ''
        //return 'keyM=' + state.apiAdd.key.keyM + '&keyU=' + state.apiAdd.key.keyU
    },
    getTemplate: () => {
        return ''
    }
}
const mutations = {
    setKeyM: (state, payload) => {
        state.apiAdd.key.keyM = payload
    },
    setKeyU: (state, payload) => {
        state.apiAdd.key.keyU = payload
    },
}
const actions = {
}

export default{
    state,
    mutations,
    getters,
    actions
}